<lvr-nav-carousel
	backLabel="Zurück"
	[backLink]="backLink()"
	[carouselElements]="carouselElements()"
	[initialIndex]="currentIndex()"
	(navigation)="onNavigate($event)"
>
</lvr-nav-carousel>

<lvr-heading
	[showEditButton]="canEditDisabilityProof()"
	[showDeleteButton]="canDeleteDisabilityProof()"
	(editClicked)="openEdit()"
	(deleteClicked)="openDialog()"
	[disableDeleteButton]="shouldNotBeDeleted()"
	[disableDeleteTranslationKey]="'client.disability.disabled_delete_proof'"
>
	{{ 'client.disability.proof' | transloco }}
</lvr-heading>

@if (proof(); as proof) {
	<section class="grid" aria-labelledby="client-disability-proof">
		<section>
			<table>
				<tr>
					<th>{{ 'client.disability.date_sb_proof' | transloco }}</th>
				</tr>
				<tr>
					<td>{{ proof.since | date: dateDisplayFormat }}</td>
				</tr>
				<tr class="row">
					<th>{{ 'client.disability.sb_status' | transloco }}</th>
				</tr>
				<tr>
					<td>
						{{ proof.status.content }}
						@if (shouldShowOtherText()) {
							{{ proof.otherText }}
						}
						@if (shouldShowSbStatusDurationInfo()) {
							<br />
							<span class="small">
								@if (proof.status.limitedUntil) {
									{{ 'client.disability.limited' | transloco }}:
									{{ proof.status.limitedUntil | date: dateDisplayFormat }}
								} @else {
									{{ 'client.disability.no_limit' | transloco }}
								}
							</span>
						}
					</td>
				</tr>
				<tr>
					<th>{{ 'client.disability.gbb_value' | transloco }}</th>
				</tr>
				<tr>
					<td>{{ proof.disabilityType }}</td>
				</tr>
			</table>
		</section>
		<section>
			<table>
				<tr>
					<th>{{ 'client.disability.remark' | transloco }}</th>
				</tr>
				<tr>
					<td>{{ proof.remark }}</td>
				</tr>
				<tr>
					<th>{{ 'client.disability.documents' | transloco }}</th>
				</tr>
				<tr>
					<td colspan="2">
						<ul>
							@for (doc of proof.documents; track doc.id) {
								<li>
									<lvr-document-item [document]="buildDocumentEntryFromDisabilityProof(doc)" (open)="onFileClick(doc)">
									</lvr-document-item>
								</li>
							}
						</ul>
					</td>
				</tr>
			</table>
		</section>
	</section>
}
